import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 10px;
  padding-top: 40;
`

export const EvolutionReportFrame = styled.iframe`
  width: 100%;
  height: 100%;
`
